import React from 'react';
import HrPerformanceReview from './HrPerformanceReview';

const Performance = () => <HrPerformanceReview variant="admin" />;

export default Performance;
